import React from 'react';

// Splits text into plain runs and @handles. An @ right after a letter, digit,
// underscore or dot is part of a word (an email address), not a mention.
export const splitMentions = (text = '') => {
  const parts = [];
  const pattern = /@\w+/g;
  let last = 0;
  let match;
  while ((match = pattern.exec(text))) {
    const before = match.index > 0 ? text[match.index - 1] : '';
    if (before && /[\w.]/.test(before)) continue;
    if (match.index > last) parts.push({ text: text.slice(last, match.index) });
    parts.push({ text: match[0], mention: true });
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
};

// @handles in brand colour, the rest as plain text.
const MentionText = ({ text = '' }) =>
  splitMentions(text || '').map((part, index) =>
    part.mention ? (
      <span key={index} className="font-medium text-brand-700">
        {part.text}
      </span>
    ) : (
      <React.Fragment key={index}>{part.text}</React.Fragment>
    )
  );

export default MentionText;
